import * as React from "react";

import StarSVG from "../../assets/Star";
import FormattedAbout from "./FormattedAbout";

export default function ProfessionalDetail({ professional, selectedDetailOption, setSelectedDetailOption, onContactClick }) {
    // const [selectedDetailOption, setSelectedDetailOption] = React.useState('about');

  return (
    <div className="flex flex-col px-1.5 pt-4 mx-auto w-full bg-white rounded-lg h-[90vh] overflow-y-scroll shadow-[-4px_4px_8px_rgba(221,221,221,0.14)]">
      <div className="flex gap-2.5 md:px-1.5 w-full bg-white rounded-xl min-h-[100px]">
        <div className="flex shrink-0 self-start border bg-white border-zinc-300 border-opacity-80 h-[100px] w-[100px]">
          {professional.imageUrl && <img src={professional.imageUrl} alt={`Company photo of ${professional.companyName}`} className="w-full h-full object-contain" />}
        </div>
        <div className="flex flex-col flex-1 shrink justify-center basis-0 min-w-[240px]">
          <div className="flex flex-col w-full text-base font-medium">
            <div className="inline-flex justify-between items-start w-full text-black">
              {/* <div>{professional.firstName + ' ' + professional.lastName}</div> */}
              <div>{professional.companyName}</div>
              <div className="inline-flex justify-between items-center gap-1">
                <div className="self-stretch my-auto">{professional?.reviewData?.overallRating}</div>
                <StarSVG />
              </div>
            </div>
            <div className="mt-2 inline-flex items-center w-auto gap-1">
              <div className="text-zinc-500 font-light">{professional.profession}</div>
              <div className="text-zinc-500 font-light px-1">|</div>
              <div className="text-zinc-500 font-light">{professional.firstName + ' ' + professional.lastName}</div>
            </div>
          </div>
          <div className="flex gap-10 justify-between items-center mt-4 w-full whitespace-nowrap text-teal-950">
            <div className="inline-flex gap-1 items-end">
              <div className="gap-2.5 self-stretch my-auto text-base font-bold w-auto">${professional?.charge?.chargeFee}</div>
              <div className="text-[12px] text-slate-600">{professional?.charge?.chargeType}</div>
            </div>
            <button 
                className="gap-2.5 self-stretch px-1 py-2 my-auto text-xs font-medium text-center rounded-md border border-solid bg-white border-shi-green"
                onClick={onContactClick}
            >
                Contact
            </button>
          </div>
        </div>
      </div>
      {/* Stats Section */}
      <div className="flex gap-5 justify-between items-center px-5 mt-8 w-full font-medium bg-white rounded-xl border border-solid border-zinc-300 border-opacity-80 min-h-[100px]">
        <div className="flex flex-col justify-between">
            <span className="text-[16px]">{professional?.experience?.yearsInService} {' Years'}</span>
            <span className="text-[14px] text-slate-500">Experience</span>
        </div>
        <div className="shrink-0 self-stretch my-auto w-0 border border-solid border-zinc-300 border-opacity-80 h-[50px]" />
        <div className="flex flex-col justify-between">
            <span className="text-[16px]">{professional?.experience?.jobsCompleted}</span>
            <span className="text-[14px] text-slate-500">Jobs Completed</span>
        </div>

        {/* REVIEWS SECTION ONCE ADDED IN GOOGLE */}
        <div className="shrink-0 self-stretch my-auto w-0 border border-solid border-zinc-300 border-opacity-80 h-[50px]" />
        <div className="flex flex-col justify-between">
            <span className="text-[16px]">{professional?.reviewData?.totalReviews}</span>
            <span className="text-[14px] text-slate-500">Reviews</span>
        </div> 
      </div>
      {/* About Section */}
      <div className="flex relative flex-col mt-8 w-full font-medium h-full">
        <div className="flex-col w-full text-base">
          <nav className="flex justify-start gap-4 items-center px-2 w-full text-zinc-500">
            <button onClick={() => setSelectedDetailOption('about')} className={`pb-1.5 ${selectedDetailOption === 'about' ? 'border-b border-shi-green text-black font-semibold' : ''}`}>About</button>
            <button onClick={() => setSelectedDetailOption('contact')} className={`pb-1.5 ${selectedDetailOption === 'contact' ? 'border-b border-shi-green text-black font-semibold' : ''}`}>Contact</button>
            <button onClick={() => setSelectedDetailOption('experience')} className={`pb-1.5 ${selectedDetailOption === 'experience' ? 'border-b border-shi-green text-black font-semibold' : ''}`}>Experience</button>
            <button onClick={() => setSelectedDetailOption('reviews')} className={`pb-1.5 ${selectedDetailOption === 'reviews' ? 'border-b border-shi-green text-black font-semibold' : ''}`}>Reviews</button>
          </nav>   
            <div className="my-6 text-black h-full w-full px-2">
                {/* {selectedDetailOption === 'about' && <div>{professional.about}</div>} */}
                {selectedDetailOption === 'about' && <FormattedAbout text={professional.about} />}
                {selectedDetailOption === 'contact' && (
                <div className="flex flex-col gap-4 ">
                    <div className="flex flex-col">
                        <p className="text-[12px] text-slate-500">Email</p>
                        <a href={`mailto:${professional.contact.email}`} className="text-blue-500 underline">{professional.contact.email}</a>
                    </div>
                    <div className="flex flex-col">
                        <p className="text-[12px] text-slate-500">Phone</p>
                        <a href={`tel:${professional.contact.phone}`} className="text-blue-500 underline">{professional.contact.phone}</a>
                    </div>
                    <div className="flex flex-col">
                        <p className="text-[12px] text-slate-500">Address</p>
                        <a 
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(professional.contact.address)}`} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="text-blue-500 underline"
                        >
                        <p>{professional.contact.address}</p>
                        </a>
                    </div>
                </div>
                )}
                {selectedDetailOption === 'experience' && (
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col">
                        <p className="text-[12px] text-slate-500">Years in Service</p>
                        <p>{professional.experience.yearsInService}</p>
                    </div>
                    <div className="flex flex-col">
                        <p className="text-[12px] text-slate-500">Jobs Completed</p>
                        <p>{professional.experience.jobsCompleted}</p>
                    </div>
                    
                </div>
                )}
                {selectedDetailOption === 'reviews' && (
                <div className="flex flex-col gap-8">
                    {professional?.reviewData?.reviews?.map((review, index) => (
                    <div key={index} className="flex flex-col gap-2">
                        <strong>{review?.author_name}</strong>
                        <div className="inline-flex gap-1 items-center">
                          <span>{review?.rating}</span>
                          <StarSVG />
                          <span className="text-slate-600 text-[12px] ml-2">{review?.relative_time_description}</span>
                        </div>
                        <span className="text-slate-600 font-inter font-light text-[14px]">{review?.text}</span>
                        <div className="border-t border-gray-300 mt-4"></div>
                    </div>
                    ))}
                </div>
                )}
            </div>
            {/* <button className="flex justify-center gap-2.5 self-stretch px-1 py-3 mt-10 items-center max-w-full text-white whitespace-nowrap rounded-md border border-white border-solid bg-shi-green h-[41px] min-h-[41px] w-[414px]">
            CONTACT
            </button> */}
        </div>
      </div>
    </div>
  );
}